import type { Container } from 'pixi.js';

/** Screen-space camera: positions the world container and applies decaying shake. */
export class Camera {
  x = 0;
  y = 0;
  scale = 1;
  private shakeAmp = 0;
  private shakeLeft = 0;
  private shakeTotal = 0;
  private ox = 0;
  private oy = 0;
  private hitStopMs = 0;

  /** Shake with `amp` px peak for `ms` milliseconds (decays linearly). Stacks by taking the max. */
  shake(amp: number, ms: number): void {
    this.shakeAmp = Math.max(this.shakeAmp, amp);
    this.shakeLeft = Math.max(this.shakeLeft, ms);
    this.shakeTotal = Math.max(this.shakeTotal, ms);
  }

  /** Freeze sim advancement for a few ms (the app consults `hitStop`). */
  hitStop(ms: number): void {
    this.hitStopMs = Math.max(this.hitStopMs, ms);
  }

  /** Returns true while a hit-stop is active; consumes dt. */
  consumeHitStop(dt: number): boolean {
    if (this.hitStopMs <= 0) return false;
    this.hitStopMs -= dt;
    return true;
  }

  update(dt: number): void {
    if (this.shakeLeft > 0) {
      this.shakeLeft -= dt;
      const k = Math.max(0, this.shakeLeft / this.shakeTotal);
      const a = this.shakeAmp * k;
      this.ox = (Math.random() * 2 - 1) * a;
      this.oy = (Math.random() * 2 - 1) * a;
      if (this.shakeLeft <= 0) {
        this.shakeAmp = 0;
        this.ox = 0;
        this.oy = 0;
      }
    }
  }

  apply(world: Container): void {
    world.position.set(this.x + this.ox, this.y + this.oy);
    world.scale.set(this.scale);
  }
}
